/*
 *
 * Ctydents reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_COURSE,
  LOAD_COURSE_SUCCESS,
  LOAD_COURSE_ERROR,
  UPDATE_COURSE,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  courseDetail: false,
  id: false,
};

/* eslint-disable default-case, no-param-reassign */
const courseDetailMobileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_COURSE:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.id = action.id;
        break;

      case LOAD_COURSE_SUCCESS:
        draft.loading = false;
        draft.courseDetail = action.courseDetail;
        break;

      case LOAD_COURSE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.courseDetail = false;
        draft.options = false;
        break;

      // Update for Single Element
      case UPDATE_COURSE:
        draft.firstRender = false;
        draft.loading = false;
        draft.error = false;
        draft.courseDetail = action.courseDetail;
        break;

      case UPDATE_COURSE_SUCCESS:
        draft.loading = false;
        draft.courseDetail = {...state.courseDetail, ...action.courseDetail};
        break;

      case UPDATE_COURSE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;
    }
  });

export default courseDetailMobileReducer;
